import React from 'react';
import { useAuth } from '../contexts/auth';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    element: React.FunctionComponentElement<any>;
}

const UnprotectedRoute: React.FC<ProtectedRouteProps> = ({element}) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation(); // Use the useLocation hook to get the current location

    return !isAuthenticated ? (
        element
    ) : (
        <Navigate to="/matchboard" replace state={{ from: location }} />
    );
};

export default UnprotectedRoute;